import { styled } from "@mui/material"

export const BreadcrumbDefaultButton = styled("button")(({ theme }) => ({
    fontSize: "12px",
    lineHeight: 1.4,
    color: theme.palette.grey[700],
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "inline",
    border: "none",
    background: "transparent",
    padding: 0,
    flexShrink: 0,
    "&:hover": {
        textDecoration: "underline",
        cursor: "pointer",
    },
    "&:active": {
        opacity: 0.8,
    },
    "&:last-of-type": {
        flexShrink: 1,
    },
}))

export const BreadcrumbTooltipButton = styled("button")(({ theme }) => ({
    fontSize: "10px",
    lineHeight: 1.4,
    color: theme.palette.grey[900],
    fontWeight: 500,
    wordWrap: "break-word",
    wordBreak: "break-word",
    display: "inline",
    border: "none",
    background: "transparent",
    padding: 0,
    "&:hover": {
        textDecoration: "underline",
        cursor: "pointer",
    },
    "&:active": {
        opacity: 0.8,
    },
}))

export const DefaultBreadcrumbWrapper = styled("span")({
    fontSize: "12px",
    lineHeight: 1.4,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
    display: "inline-flex",
    cursor: "default",
    flexWrap: "nowrap",
})

// Wrapper that shows the full path on wider screens
export const FullBreadcrumbWrapper = styled("span")(({ theme }) => ({
    display: "none", // Hidden by default on mobile
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",

    // Show on screens wider than medium breakpoint
    [theme.breakpoints.up("md")]: {
        display: "inline-flex",
    },
}))

// Wrapper that shows the truncated path on smaller screens
export const TruncatedBreadcrumbWrapper = styled("span")(({ theme }) => ({
    display: "inline-flex", // Visible by default on mobile
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",

    // Hide on screens wider than medium breakpoint
    [theme.breakpoints.up("md")]: {
        display: "none",
    },
}))

export const containerStyle = {
    display: "flex" as const,
    flexWrap: "nowrap" as const,
    overflow: "hidden" as const,
    textOverflow: "ellipsis" as const,
    fontSize: "12px",
    lineHeight: 1.4,
    cursor: "default",
}
